<script>import { onMount } from "svelte";
import { cn } from "../../utils/twClnm.js";
import { clickOutsideFallback } from "../../utils/clickOutside.js";
export let id;
export let buttonClass = "";
export let toggleClass = "";
export let idData = "onscroll";
export let isStatic = false;
export let isCloseOnOutsideClick = false;
export let hoverEnabled = false;
export let buttonDetails = "";
export let tooltipList = "";
export let additionalClickEvent = () => {
};
export let handleOutsideEventsExternalId = "";
let toggle = false;
let clientX = 0;
let clientY = 0;
let bottomOffset = 0;
let isHovering = false;
let hoverX = 0;
let hoverY = 0;
const toggleToolbar = () => {
  toggle = !toggle;
  document.querySelectorAll(`#${idData}`).forEach((e) => e.remove());
  tooltipRect();
};
const showTooltip = (event) => {
  if (hoverEnabled) {
    isHovering = true;
    updateHoverPosition(event);
  }
};
const hideTooltip = () => {
  if (hoverEnabled) {
    isHovering = false;
  }
};
onMount(() => {
  window.addEventListener("scroll", () => {
    tooltipRect();
  });
});
const updateHoverPosition = (event) => {
  const padding = 10;
  const tooltipWidth = 200;
  const tooltipHeight = 100;
  hoverX = Math.min(Math.max(event.clientX, padding), window.innerWidth - tooltipWidth - padding);
  hoverY = Math.min(Math.max(event.clientY, padding), window.innerHeight - tooltipHeight - padding);
};
const tooltipRect = () => {
  if (isStatic) {
    return;
  }
  const tooltip = document.querySelector(`#${idData}-${id}`);
  if (!tooltip) return;
  const tooltipRect2 = tooltip.getBoundingClientRect();
  const tooltipX = tooltipRect2.left;
  const tooltipY = tooltipRect2.top;
  clientX = tooltipX + 10;
  clientY = tooltipY + 10;
  bottomOffset = window.innerHeight - tooltipY - tooltipRect2.height - 28;
};
const onClickOutside = (event) => {
  const tooltipElement = document.getElementById(idData);
  let flag = false;
  let elementIds = [];
  if (!Array.isArray(handleOutsideEventsExternalId)) elementIds = [handleOutsideEventsExternalId];
  else elementIds = handleOutsideEventsExternalId;
  const targetElement = event.target;
  elementIds.forEach((elementId) => {
    const saveButtonElement = document.getElementById(elementId);
    const isSaveButtonClick = saveButtonElement?.contains(targetElement);
    if (isSaveButtonClick) flag = true;
  });
  const isInsideCurrentTooltip = tooltipElement?.contains(targetElement);
  if (!isInsideCurrentTooltip && !flag) {
    toggle = false;
  }
  if (flag) {
    additionalClickEvent?.();
    return;
  }
  if (!flag) {
    event.stopPropagation();
  }
};
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="w-full" on:mouseenter={showTooltip} on:mouseleave={hideTooltip}>
	<button
		on:click={() => {
			if (!hoverEnabled) {
				toggleToolbar();
				additionalClickEvent();
			} else {
				()=>{}
			}
		}}
		data-tooltip-target="tooltip-right"
		id="{idData}-{id}"
		class={cn(`button`,buttonClass)}
	>
		<slot name="button-details"></slot>
		{buttonDetails}
	</button>

	{#if toggle}
		<!-- Display tooltip on click or hover -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<button
			style={`left: ${clientX}px; ${clientY > (window.innerHeight - 275) ? `bottom: ${bottomOffset}px;` : `top: ${clientY}px;`} ${isHovering ? 'transition: opacity 5.50s ease-in-out;' : ''}`}
			data-tooltip="tooltip-right"
			data-tooltip-placement="right"
			id={idData}
			class={cn(`tw-onscroll tw-fixed tw-z-50 tw--mt-8 tw-ml-2 tw-w-auto tw-max-w-full tw-whitespace-normal tw-break-words tw-rounded-[6px] 
									tw-border tw-border-border tw-bg-white tw-p-[15px] tw-font-inter tw-text-sm tw-font-medium tw-text-dark
									tw-shadow-[0_0_16px_0_rgba(0,0,0,0.15)] focus:tw-outline-none`, toggleClass)}
			use:clickOutsideFallback={isCloseOnOutsideClick ? onClickOutside : ()=>{}}
			on:click={(event)=>{
				if(!event?.target?.classList?.contains('tooltip-close-element')) return;
				toggleToolbar();
			}}
		>
			<slot name="tooltip-list"></slot>
			{tooltipList}
		</button>
	{/if}

	{#if isHovering}
		<!-- Hover tooltip -->
		<div
			style={`left: ${hoverX}px; top: ${hoverY}px;`}
			class={cn(`tw-fixed tw-z-50 tw-w-auto tw-max-w-[200px] tw-whitespace-normal tw-break-words tw-rounded-[6px] 
									tw-border tw-border-border tw-bg-white tw-p-[15px] tw-font-inter tw-text-sm tw-font-medium tw-text-dark
									tw-shadow-[0_0_16px_0_rgba(0,0,0,0.15)] focus:tw-outline-none`, toggleClass)}
		>
			<slot name="tooltip-list"></slot>
			{tooltipList}
		</div>
	{/if}
</div>
